export default __webpack_public_path__ + "static/media/digital-agency.cd7a3594.svg";